import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../api-services/api-service';

// Create RJ Poster
export const createRjPoster = createAsyncThunk('rj/createRjPoster', async ({ adminData, payload }) => {
  const { id: empId, acessToken } = adminData;
  const response = await apiService.createRjPoster(empId, acessToken, payload);
  return response;
});

// Update RJ Poster
export const updateRjPoster = createAsyncThunk('rj/updateRjPoster', async ({ adminData, payload }) => {
  const { id: empId, acessToken } = adminData;
  const response = await apiService.updateRjPoster(empId, acessToken, payload);
  return response;
});

// Delete RJ Poster
export const deleteRjPoster = createAsyncThunk('rj/deleteRjPoster', async ({ adminData, rjPosterId }) => {
  const { id: empId, acessToken } = adminData;
  const response = await apiService.deleteRjPoster(empId, acessToken, rjPosterId);
  return response;
});

const rjSlice = createSlice({
  name: 'rj',
  initialState: {
    loading: false,
    error: null,
    success: false,
    updateLoading: false,
    updateError: null,
    updateSuccess: false,
    deleteLoading: false,
    deleteError: null,
    deleteSuccess: false,
  },
  reducers: {
    clearRjState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.updateLoading = false;
      state.updateError = null;
      state.updateSuccess = false;
      state.deleteLoading = false;
      state.deleteError = null;
      state.deleteSuccess = false;
    }
  },
  extraReducers: (builder) => {
    builder
      // Create RJ Poster
      .addCase(createRjPoster.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createRjPoster.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createRjPoster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.success = false;
      })
      // Update RJ Poster
      .addCase(updateRjPoster.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
        state.updateSuccess = false;
      })
      .addCase(updateRjPoster.fulfilled, (state) => {
        state.updateLoading = false;
        state.updateSuccess = true;
      })
      .addCase(updateRjPoster.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.error.message;
        state.updateSuccess = false;
      })
      // Delete RJ Poster
      .addCase(deleteRjPoster.pending, (state) => {
        state.deleteLoading = true;
        state.deleteError = null;
        state.deleteSuccess = false;
      })
      .addCase(deleteRjPoster.fulfilled, (state) => {
        state.deleteLoading = false;
        state.deleteSuccess = true;
      })
      .addCase(deleteRjPoster.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteError = action.error.message;
        state.deleteSuccess = false;
      });
  },
});

export const { clearRjState } = rjSlice.actions;
export default rjSlice.reducer;